import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import Button from "../../components/common/Button";
import { getJoinLink } from "../../backend/landing/joinLink";
import { getDays } from "../../backend/weekends/schedule";
import { sanitizeHTML } from "../../utils/htmlSanitizer";

const DayView = ({
    dayHeading,
    daySubHeading,
    text,
}: {
    dayHeading: string;
    daySubHeading: string;
    text: string;
}) => {
    const isMobile = useMediaQuery({ query: `(max-width: 768px)` });
    return (
        <div style={styles.dayContainer}>
            {dayHeading != " " && (
                <div
                    style={{
                        ...styles.dayHeadingContainer,
                        paddingLeft: isMobile ? "1rem" : "2rem",
                    }}
                >
                    <p
                        style={{
                            ...styles.dayHeadingText,
                            fontSize: isMobile ? "max(3rem,14vw)" : "4rem",
                        }}
                    >
                        {dayHeading}
                    </p>
                    <p
                        style={{
                            ...styles.daySubHeadingText,
                            fontSize: isMobile ? "max(2rem,10vw)" : "2.75rem",
                        }}
                    >
                        {daySubHeading}
                    </p>
                </div>
            )}
            <div
                dangerouslySetInnerHTML={{ __html: sanitizeHTML(text) }}
                style={{ fontSize: isMobile ? "7vw" : "2.25rem" }}
            />
        </div>
    );
};

const LandingSchedule = ({ weekendId }: {weekendId:number}) => {
    const showBigLogo = useMediaQuery({ query: `(min-width: 1024px)` });
    const isMobile = useMediaQuery({ query: `(max-width: 768px)` });
    const dayList = getDays(weekendId);
    return (
        <div style={{ ...styles.scheduleWrapper, flexDirection: isMobile ? "column" : "row" }}>
            <div
                style={{
                    ...styles.scheduleContainer,
                    margin: isMobile ? "3.5rem auto" : "5rem auto",
                }}
            >
                <p
                    style={{
                        ...styles.mainHeading,
                        fontSize: isMobile ? "9.7vw" : "clamp(3rem,4vw,5rem)",
                    }}
                >
                    Що на тебе чекає
                </p>
                {dayList.map((item) => (
                    <DayView
                        dayHeading={item.dayHeading}
                        daySubHeading={item.daySubheading}
                        text={item.description}
                    />
                ))}
                <div style={{ display: "flex", flexDirection: "row" }}>
                    <Button
                        text={"ЙДУ НА ВИШКІЛ"}
                        external_link={getJoinLink(weekendId)}
                        textColor="var(--black)"
                        hoverTextColor="var(--orange)"
                        border="3px solid var(--black)"
                        hoverBorder="3px solid var(--black)"
                        backgroundColor="var(--orange)"
                        hoverBackgroundColor="var(--black)"
                        fontSize={isMobile ? "9vw" : "3rem"}
                        padding={isMobile ? "1rem 0rem" : "1rem 2rem"}
                        fontWeight="bold"
                        containerProps={isMobile ? { width: "var(--main-container-width)" } : {}}
                        isSimple={true}
                    />
                </div>
            </div>
        </div>
    );
};

const styles: Record<string, React.CSSProperties> = {
    scheduleWrapper: {
        display: "flex",
        width: "100%",
        backgroundColor: "var(--olive)",
        overflow: "visible",
    },
    scheduleContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        width: "var(--main-container-width)",
    },
    mainHeading: {
        color: "var(--dark-grey)",
        fontWeight: "bold",
        marginBottom: "3.5rem",
    },
    descriptionText: {
        color: "var(--dark-grey)",
        marginBottom: "3.5rem",
    },
    dayContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "3rem",
        paddingBottom: "4rem",
    },
    dayHeadingContainer: {
        display: "flex",
        flexDirection: "column",
        borderLeft: "2px solid var(--black)",
        gap: "1rem",
    },
    dayHeadingText: {
        color: "var(--white)",
        fontWeight: "bold",
    },
    daySubHeadingText: {
        color: "var(--white)",
    },
};

export default LandingSchedule;
